const PATH = 'fe.pages.calibrations';

const messages = {
  title: {
    key: `${PATH}.title`,
    defaultValue: 'CALIBRATIONS'
  },
  current: {
    key: `${PATH}.current`,
    defaultValue: 'Current Calibrations'
  },
  history: {
    key: `${PATH}.history`,
    defaultValue: 'Calibration History'
  },
  purchase: {
    key: `${PATH}.purchase`,
    defaultValue: 'Purchase a Calibration'
  },
  noData: {
    key: `${PATH}.no_data`,
    defaultValue: 'No Results Found'
  }
};

export default messages;
